import {
    // activities
    FETCH_NEWS_FEED_ACTIVITIES,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY,
    UPDATE_NEWS_FEED_ERROR_STATE,
    FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES,
    // comments
    FETCH_NEWS_FEED_COMMENTS,
    ADD_NEWS_FEED_COMMENT,
    EDIT_NEWS_FEED_COMMENT,
    REMOVE_NEWS_FEED_COMMENT,
    FETCH_NEWS_FEED_COMMENT_LIKERS,
    // likes
    FETCH_NEWS_FEED_CONVERSATION_LIKES,
    FETCH_NEWS_FEED_COMMENT_LIKES,
    ADD_NEWS_FEED_COMMENT_LIKE,
    REMOVE_NEWS_FEED_COMMENT_LIKE,
    ADD_NEWS_FEED_CONVERSATION_LIKE,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE,
    // connection
    REMOVE_CONNECTION,
    MUTE_CONNECTION,
    UNMUTE_CONNECTION,
    FETCH_MUTED_CONNECTION_LIST,
    FETCH_CONNECTION_COUNT,
    FETCH_SUGGESTED_CONNECTION_LIST,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST,
    UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING,
    REMOVE_PAGED_SUGGESTED_CONNECTION,
    CLEAR_PAGED_SUGGESTED_CONNECTION_LIST,
    FETCH_SUGGESTED_CONNECTIONS_COUNT,
    // reporter
    NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG,
    NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG,
    NEWS_FEED_SUMBIT_REPORT_PHOTO,
    NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE,
    NEWS_FEED_REMOVE_IMAGE_FROM_FEED,
    // reset
    RESET_NEWS_FEED_ACTIVITIES,
    RESET_NEWS_FEED_COMMENTS,
    RESET_NEWS_FEED_LIKES,
    RESET_NEWS_FEED_CONNECTIONS
} from './ActionTypes';

// activities
export function fetchNewsfeedActivities(payload) {
    return {
        type: FETCH_NEWS_FEED_ACTIVITIES,
        payload
    };
}
export function updateNewsfeedActivityPrivacy(payload) {
    return {
        type: UPDATE_NEWS_FEED_ACTIVITY_PRIVACY,
        payload
    };
}
export function updateNewsfeedActivityLikes(activityId) {
    return {
        type: FETCH_NEWS_FEED_ACTIVITY_AND_UPDATE_LIKES,
        activityId
    };
}

// error state
export function updateNewsfeedErrorState({ hasError }) {
    return {
        type: UPDATE_NEWS_FEED_ERROR_STATE,
        hasError
    };
}
export function setNewsfeedErrorState() {
    return {
        type: UPDATE_NEWS_FEED_ERROR_STATE,
        hasError: true
    };
}
export function resetNewsfeedErrorState() {
    return {
        type: UPDATE_NEWS_FEED_ERROR_STATE,
        hasError: false
    };
}

// comments
export function fetchNewsFeedComments(payload) {
    return {
        type: FETCH_NEWS_FEED_COMMENTS,
        payload
    };
}
export function addNewsFeedComment(payload) {
    return {
        type: ADD_NEWS_FEED_COMMENT,
        payload
    };
}
export function editNewsFeedComment(payload) {
    return {
        type: EDIT_NEWS_FEED_COMMENT,
        payload
    };
}
export function removeNewsFeedComment(payload) {
    return {
        type: REMOVE_NEWS_FEED_COMMENT,
        payload
    };
}

// comment likes
export function fetchNewsFeedCommentLikes(payload) {
    return {
        type: FETCH_NEWS_FEED_COMMENT_LIKES,
        payload
    };
}
export function addNewsFeedCommentLike(payload) {
    return {
        type: ADD_NEWS_FEED_COMMENT_LIKE,
        payload
    };
}
export function removeNewsFeedCommentLike(payload) {
    return {
        type: REMOVE_NEWS_FEED_COMMENT_LIKE,
        payload
    };
}
export function fetchNewsFeedCommentLikers(payload) {
    return {
        type: FETCH_NEWS_FEED_COMMENT_LIKERS,
        payload
    };
}

// conversation likes
export function addNewsFeedConversationLike(payload) {
    return {
        type: ADD_NEWS_FEED_CONVERSATION_LIKE,
        payload
    };
}
export function removeNewsFeedConversationLike(payload) {
    return {
        type: REMOVE_NEWS_FEED_CONVERSATION_LIKE,
        payload
    };
}
export function fetchNewsFeedConversationLikes(payload) {
    return {
        type: FETCH_NEWS_FEED_CONVERSATION_LIKES,
        payload
    };
}

// connections
export function removeConnection(payload) {
    return {
        type: REMOVE_CONNECTION,
        payload
    };
}
export function muteConnection(payload) {
    return {
        type: MUTE_CONNECTION,
        payload
    };
}
export function unmuteConnection(payload) {
    return {
        type: UNMUTE_CONNECTION,
        payload
    };
}
export function fetchMutedConnectionList() {
    return {
        type: FETCH_MUTED_CONNECTION_LIST
    };
}
export function fetchConnectionCount() {
    return {
        type: FETCH_CONNECTION_COUNT
    };
}
export function fetchSuggestedConnectionList(payload) {
    return {
        type: FETCH_SUGGESTED_CONNECTION_LIST,
        payload
    };
}
export function fetchPagedSuggestedConnectionList(payload) {
    return {
        type: FETCH_PAGED_SUGGESTED_CONNECTION_LIST,
        payload
    };
}
export function updatePagedSuggestedConnectionDismissing(payload) {
    return {
        type: UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING,
        payload
    };
}
export function removePagedSuggestedConnection(payload) {
    return {
        type: REMOVE_PAGED_SUGGESTED_CONNECTION,
        payload
    };
}
export function clearPagedSuggestedConnectionList() {
    return {
        type: CLEAR_PAGED_SUGGESTED_CONNECTION_LIST
    };
}
export function fetchSuggestedConnectionsCount(payload) {
    return {
        type: FETCH_SUGGESTED_CONNECTIONS_COUNT,
        payload
    };
}

// reporter
export function openReportPhotoDialog({ activityId, imageUuid }) {
    return {
        type: NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG,
        activityId,
        imageUuid
    };
}

export function closeReportPhotoDialog() {
    return {
        type: NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG
    };
}

export function submitReportPhoto({ flagReason, note }) {
    return {
        type: NEWS_FEED_SUMBIT_REPORT_PHOTO,
        flagReason,
        note
    };
}

export function submitReportPhotoDone({ error = false, reviewStatus }) {
    return {
        type: NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE,
        error,
        reviewStatus
    };
}

export function removePhotoFromFeed({ activityId, imageUuid }) {
    return {
        type: NEWS_FEED_REMOVE_IMAGE_FROM_FEED,
        activityId,
        imageUuid
    };
}

// reset
export function resetNewsfeedActivities() {
    return {
        type: RESET_NEWS_FEED_ACTIVITIES
    };
}
export function resetNewsfeedComments() {
    return {
        type: RESET_NEWS_FEED_COMMENTS
    };
}
export function resetNewsfeedLikes() {
    return {
        type: RESET_NEWS_FEED_LIKES
    };
}
export function resetNewsfeedConnections() {
    return {
        type: RESET_NEWS_FEED_CONNECTIONS
    };
}
